import { Component, OnInit, Input } from '@angular/core';
import { StmgService } from '../../../services/state_Management/stmg.service';
import { BettingServiceService } from "../../../services/betting_service/betting-service.service";
import { AlertComponent } from "../../../components/alert/alert.component";
import { AlertController } from "@ionic/angular";
import { interval, Subscription, timer } from 'rxjs';
import { CommonServiceService } from '../../../services/common_service/common-service.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-sport-details',
  templateUrl: './sport-details.component.html',
  styleUrls: ['./sport-details.component.scss'],
})
export class SportDetailsComponent implements OnInit {

  @Input() selectedMeeting: any;
  selectionOdds: any = [];

  selectionType: string = "";
  maxCount: boolean = false;
  selection: any = {
    eventSelections: []
  };
  subscription: Subscription;
  disable_SP_subscription: Subscription;
  mySubscription: Subscription;

  currentSelectedBets: any = null;    // Block Games

  constructor(
    private stmgService: StmgService,
    private bettingService: BettingServiceService,
    public alertController: AlertController,
    private commonservice: CommonServiceService,
    public translate: TranslateService,
  ) {
    //refresh when remove all from bet slip modal
    this.disable_SP_subscription = this.commonservice.getClickEvent().subscribe(() => {
      this.selectionOdds.forEach(element => {
        element.clicked = false;
      });

    })

  }

  countDown: Subscription;
  counter = 15;
  tick = 1000;
  rotate = false;

  ngOnInit() {
    this.getSelectionOdds(this.selectedMeeting.id);
    //get selected bets
    this.subscription = this.stmgService.cast_selectedBets.subscribe(selectedBets => {
      if (selectedBets) {
        this.selection = selectedBets;
      }
    });

    //run every 5 seconds
    this.mySubscription = interval(15000).subscribe((x => {
      this.rotate = true;
      this.getSelectionOdds(this.selectedMeeting.id);
      this.counter = 15;
    }));

    this.countDown = timer(0, this.tick)
      .subscribe(() => {
        --this.counter;
        if (this.counter == -1) {
          this.counter = 15;
        }
        // if (this.counter == 27) {
        //   this.rotate = false;
        // }
      });

    // Block Games
    this.stmgService.cast_selectedBets.subscribe(bets => {
      this.currentSelectedBets = bets;
      // console.log('Game - Subscription updated:', bets);
    });

  }

  //stop the 5 seconds loop
  ngOnDestroy() {
    this.mySubscription.unsubscribe();
    this.countDown.unsubscribe();
  }

  backToMettingView() {
    this.stmgService.updateResultBackButton(false);
  }

  click_reload() {
    this.getSelectionOdds(this.selectedMeeting.id);
    this.counter = 15;
    this.rotate = true;
  }

  getSelectionOdds(id: any) {
    this.bettingService.getEventSelections(id).subscribe(
      (data) => {
        this.selectionOdds = data;

        //auto select clicked bets
        for (let index = 0; index < this.selectionOdds.length; index++) {
          for (let i = 0; i < this.selection.eventSelections.length; i++) {
            if (this.selectionOdds[index].id == this.selection.eventSelections[i].id) {
              this.selectionOdds[index].clicked = true;
            }
          }
        }

      },
      (error) => { }
    );
  }

  setSPOdd(value: any) {

    this.selectionType = 'SP';
    value.clicked = !value.clicked;

    if (value.clicked == true) {
      this.maxCount = this.checkMaximuSelectionCount();
      if (this.maxCount == false) {
        this.placeBetObj(value, this.selectionType);
      } else {
        value.clicked = false;
        this.showMaxCountAlert();
      }
    } else {
      this.placeBetObj(value, this.selectionType);
    }


  }

  // checkMaximuSelectionCount() {
  //   let val: boolean;
  //   let selectionArray=this.selection.eventSelections.filter(m=>!m.isKR3)
  //   if(selectionArray.length == 4){
  //     val = true;
  //   } else {
  //     val = false;
  //   }
  //   return val;
  // }

  checkMaximuSelectionCount(): boolean {

    if (!this.selection || !this.selection.eventSelections) {
      return false;
    }

    const selectionArray = this.selection.eventSelections.filter(m => !m?.isKR3);

    return selectionArray.length === 4;
  }

  placeBetObj(d: any, t: string) {

    // Block Games Selections
    if (!this.selection) {
      this.selection = { eventSelections: [] };
    }
    if (!this.selection.eventSelections) {
      this.selection.eventSelections = [];
    }

    // **CHECK if game bets exist**
    if (this.currentSelectedBets && this.currentSelectedBets !== '') {
      console.log('Sports - Inside check, currentBets exists');
      
      const isKironGame = this.currentSelectedBets.payload && (this.currentSelectedBets.payload['@rule'] === 'FeedId88BettingOptions' || this.currentSelectedBets.payload['@rule'] === 'FeedId86BettingOptions' || this.currentSelectedBets.payload['@rule'] === 'FeedId87BettingOptions');
      console.log('Sports - isKironGame:', isKironGame);
      
      if (isKironGame && this.currentSelectedBets.payload.eventSelections) {
        const hasGameBets = this.currentSelectedBets.payload.eventSelections.length > 0;
        console.log('Sports - hasGameBets:', hasGameBets);
        
        if (hasGameBets) {
          this.showBlockAlert();
          d.clicked = false;
          d.fr_clicked = false;
          return;
        }
      }
    }

    let oddD: any;
    let oddF: any;
    let win: number = 0;
    let place: number = 0;

    switch (t) {

      case 'SP':
        oddF = 'N';
        oddD = 0.0;
        break;

      case 'PO':
        oddF = d.priceOdds.priceFraction;
        oddD = 0.0;
        break;

      case 'PD':
        oddF = 'N';
        oddD = d.priceOdds.priceDecimal;
        break;

    }

    let tempObj = {
      id: d.id,
      oddD: oddD,
      oddF: oddF,
      win: win,
      place: place,
      sportType: d.id
    }

    if (d.clicked == true) {
      this.maxCount = this.checkMaximuSelectionCount();
      let index = -1;
      for (let i = 0; i < this.selection.eventSelections.length; i++) {
        if (this.selection.eventSelections[i].id == d.id) {
          index = i;
          break;
        }
      }

      // add row
      if (index == -1) {
        this.selection.eventSelections.push(tempObj);
      }


    } else {
      let index = -1;
      for (let i = 0; i < this.selection.eventSelections.length; i++) {
        if (this.selection.eventSelections[i].id == d.id) {
          index = i;
          // remove row
          this.selection.eventSelections.splice(index, 1);
          break;
        }
      }
    }
    this.stmgService.updateSelecteBets(this.selection);
  }


  showMaxCountAlert() {
    let alertTitle:string;
    let alertDesc:string;
    this.translate.get('ALERTS.MAX_COUNT.TITLE').subscribe((res: string) => {
      alertTitle=res;
    });
    this.translate.get('ALERTS.MAX_COUNT.DESC').subscribe((res: string) => {
      alertDesc=res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert("",alertTitle,alertDesc);
  }


  // Block Slecetion with Games
  showBlockAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.BLOCK_SELECTIONS.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.BLOCK_SELECTIONS.DESC').subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert("", alertTitle, alertDesc);
  }
}






